import React, { FC } from 'react'

import { Box, Button, Text, dimensions } from '@factorialco/deprecated-design-system'

import DocumentType from 'modules/core/components/DocumentType'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { usePreviewProvider } from '../../../Providers/preview'
import { TaskConfigurationAttachments } from '../../FilesList/types'

type IFile = TaskConfigurationAttachments & File

export const buildFiles = (
  filesToAdd: IFile[],
  filesToRemove: Set<number>,
  currentFiles?: IFile[]
) => {
  return [...(currentFiles ?? []), ...(filesToAdd || [])].filter(
    (file: IFile) => file && !Array.from(filesToRemove || [])?.includes(file?.id)
  )
}

export const File: FC<{ file: IFile }> = ({ file }) => {
  const isImage = file.type?.includes('image') || file.contentType?.includes('image')
  const src = file.contentType ? buildUrl(file.path) : URL.createObjectURL(new Blob([file]))

  return (
    <Box paddingY="s16">
      <Box
        background="grey000White"
        borderRadius={{ all: 'abs008' }}
        gap="s12"
        paddingX="s24"
        paddingY="s16"
        border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
      >
        <Box flexDirection="row" alignItems="center" gap="s12">
          {isImage ? (
            <Box width="s80" height="s48">
              <img
                src={src}
                alt={file.name}
                style={{ maxWidth: dimensions.s80, maxHeight: dimensions.s48 }}
              />
            </Box>
          ) : (
            <DocumentType mimetype={String(file.type || file.contentType)} />
          )}

          <Text.Normal weight="medium" color="grey800" size="300" overflowWrap>
            {file.name || file.filename}
          </Text.Normal>
        </Box>

        <Box flexDirection="row" alignItems="center">
          <Box paddingRight="s8">
            <Button type="secondary" iconName="ellipsis" />
          </Box>

          <Button type="secondary" iconName="arrow-right" />
        </Box>
      </Box>
    </Box>
  )
}

const Attachments = () => {
  const { previewValues } = usePreviewProvider()
  const { filesToAdd, currentFiles, filesToRemove } = previewValues

  const files = buildFiles(filesToAdd, filesToRemove, currentFiles)
  if (!files || files.length === 0) return null

  return (
    <Box paddingY="s16">
      <Text.Normal weight="semibold" color="grey1000">
        {i18n.t('processes.process_settings.wizard.tasks.preview.attachments')}
      </Text.Normal>
      {files.map((file, index: number) => {
        return <File key={index} file={file} />
      })}
    </Box>
  )
}

export default Attachments
